module.exports = __webpack_public_path__ + "static/media/hero.c37cdbe2.png";